export default "__VITE_ASSET__BzwOqNQ9__"